import { useState } from 'react';
import IconArrowRight from '../icons/arrow-right';
import IconUp from '../icons/up';
import IconDown from '../icons/down';
import { BaseellaStatusTitle, StatusItemTypes } from './types';

import styles from './transaction.module.css';

export default function StatusItem({
  isLoadingStatuses,
  item,
  onStatusTransition,
  updateStatusIsLoading,
  disabled,
}: StatusItemTypes) {
  const [collapsed, setCollapsed] = useState(false);

  let buttonText = 'Next status';
  let buttonIcon = <IconArrowRight />;

  if (!item.allowed) {
    buttonText = 'Conditions are not met';

    buttonIcon = collapsed ? (
      <IconUp className={styles.arrowIcon} />
    ) : (
      <IconDown className={styles.arrowIcon} />
    );
  }

  return (
    <div className={styles.statusItemWrapper}>
      <button
        type="button"
        className={`${styles.statusChangeWrapper} ${
          isLoadingStatuses || disabled ? styles.statusButtonDisabled : ''
        }`}
        onClick={() =>
          item.allowed
            ? onStatusTransition(item.baseellaStatusNext)
            : setCollapsed(!collapsed)
        }
        key={item.baseellaStatusNext}
        disabled={isLoadingStatuses || disabled}
      >
        <div className={styles.statusChangeValue}>
          {BaseellaStatusTitle[item.baseellaStatusNext]}
          {!item.errors && item?.warnings && item?.warnings?.length > 0 && (
            <ul className={styles.warningsWrapper}>
              {item?.warnings?.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          )}
        </div>
        <div
          className={`${styles.changeStatusButton} ${
            !item.allowed ? styles.redText : ''
          }`}
        >
          {updateStatusIsLoading ? (
            'Loading...'
          ) : (
            <>
              {buttonText}
              {buttonIcon}
            </>
          )}
        </div>
      </button>
      {collapsed && (
        <>
          <ul className={styles.errorsList}>
            {item?.errors?.map((error, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`${error}-${index}`}>{error}</li>
            ))}
          </ul>
          {item?.warnings && item?.warnings?.length > 0 && (
            <ul
              className={`${styles.warningsWrapper} ${styles.errorsWranings}`}
            >
              {item?.warnings?.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
}
